import * as React from 'react';

import { Link } from '../../../Link/Link';
import { VisuallyHidden } from '../../../VisuallyHidden/VisuallyHidden';
import { Stack } from '../../../Stack/Stack';

import * as cs from './BlogPostHeroTranslations.module.css';

interface Props {
  entries: Queries.BlogPostPageEntryFragment['translations'];
}

export const BlogPostHeroTranslations = ({ entries }: Props) => (
  <Stack as="section" direction="vertical" gap={24}>
    <VisuallyHidden as="h2">Translations</VisuallyHidden>
    {entries && entries.length > 0 && (
      <ul>
        {entries.map((entry) => (
          <li className={cs.item} key={entry.url}>
            <span className={cs.language}>{entry.language}</span>
            <Link to={entry.url} target="_blank">
              {entry.title}
            </Link>
          </li>
        ))}
      </ul>
    )}
  </Stack>
);
